import { URLS } from 'core/dna/routing';

import { LockCallback } from 'auth/dna/types';

import AuthUrls from 'auth/urls';

export const defaultLockCallback: LockCallback = (options) => {
  options?.navigateTo?.(AuthUrls.lock(options?.locale ?? URLS.defaultLocale));
};
